<div class="flex flex-col w-full h-full justify-start items-stretch overflow-hidden">
  <app-page-header>
    <span>IFC Viewer</span>
  </app-page-header>

  <div class="flex flex-col w-full h-full p-6 gap-6 overflow-hidden">
    @if (loading) {
      <div class="flex flex-col w-full h-full justify-center items-center gap-2">
        <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
        <span class="text-sm font-medium text-gray-500">IFC-Modelle werden geladen...</span>
      </div>
    }
    @if (!loading) {
      <app-files
        [(selectedFiles)]="selectedFiles"
        [calledFromCheck]="true"
        [customFilesActivated]="true"
        [customFiles]="ifcFiles"
        [filterAndContextButtonActivated]="true"
        [headline]="'IFC-Modelle'"
        [noOuterPadding]="true"
        class="flex w-full h-full">
      </app-files>
    }

    <div class="flex flex-row w-full justify-center items-center shrink-0 gap-4">
      <bic-button
        (onClick)="openIFCViewer()"
        [disabled]="getSelectedIfcFiles().length !== 1"
        [tooltipDirection]="'top'"
        [tooltip]="getSelectedIfcFiles().length !== 1 ? 'Bitte genau eine IFC-Datei auswählen' : undefined"
        buttonType="white">
        Im Viewer öffnen
        <fa-icon [icon]="faArrowUpRightFromSquare" iconRight></fa-icon>
      </bic-button>
      <bic-button
        (onClick)="openCoordinationModel()"
        [disabled]="getSelectedIfcFiles().length < 2"
        [tooltipDirection]="'top'"
        [tooltip]="getSelectedIfcFiles().length < 2 ? 'Bitte mindestens zwei IFC-Dateien auswählen' : undefined">
        Koordinationsmodell
        <fa-icon [icon]="faLayerGroup" iconRight></fa-icon>
      </bic-button>
    </div>
  </div>
</div>

